import React, { useCallback } from 'react';
import { Card, Row, Col, Nav } from 'react-bootstrap';
import FollowersSvg from '../assets/icons/couple-family-icon.svg';
import LikeSvg from '../assets/icons/red-heart-icon.svg';
import CommentsSvg from '../assets/icons/positive-feedback-icon.svg';
import ViewsSvg from '../assets/icons/eye-icon.svg';
import Instagram from '../assets/icons/Instagram_24px.svg';
import Tiktok from '../assets/icons/Tiktok_24px.svg';
import PerformanceEmptyState from '../assets/icons/performance-empty.svg'
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';
import PerformanceDetails from './PerformanceDetails'

function PerformaceCard({ performanceData, handlePlatformLink, accountInfo, activeLink }) {
    
    return (
        <>
            <Card id='performance' className='performance-card border rounded-top-4 rounded-bottom-0 mt-3'>
                <Card.Body>
                    <div className='info-header-title'>Performance</div>
                    <div className='my-3'>
                        <Nav variant="underline" className='performance-type-tabs pb-0'>
                            {accountInfo.instagramUsername && (
                                <Nav.Item>
                                    <Nav.Link
                                        active={activeLink === 'Instagram'}
                                        onClick={() => handlePlatformLink('Instagram')}
                                        className='px-2'
                                    >
                                        <img src={Instagram} width={20} height={20} className='mx-1' /> Instagram
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                            {accountInfo.tikTokUsername && (
                                <Nav.Item>
                                    <Nav.Link
                                        active={activeLink === 'TikTok'}
                                        onClick={() => handlePlatformLink('TikTok')}
                                        className='px-2'
                                    >
                                        <img src={Tiktok} width={20} height={20} className='mx-1' /> TikTok
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                        </Nav>
                    </div>
                    <ErrorBoundary
                        FallbackComponent={(props) => <ErrorFallback {...props} image={PerformanceEmptyState} title="Performance" />}
                    >
                    <PerformanceDetails performanceData={performanceData} />
                    </ErrorBoundary>
                </Card.Body>
            </Card>
        </>
    )
}

export default PerformaceCard
